import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  return (
    <div className="footer h-10 bg-customWhite/15 text-white flex items-center justify-center">
      <div className="footer-text text-center">
        {t("footer.copyright", { year: currentYear })}
      </div>
    </div>
  );
}

export default Footer;
